<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'
import _isArray from 'lodash/isArray'

import INVENTORY_TYPES from 'constants/inventoryTypes'

export default {
  name: 'checkout-items',
  props: {
    complete: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      booking: (state) => state.checkout.booking,
    }),
    _items() {
      if (_isArray(this.items)) return this.items
      if (this.booking) return this.booking.items
      return []
    },
  },
  methods: {
    getItemQuantityMax(item) {
      return item.inventory.purchaseMax || item.inventory.quantity || 1
    },
    showItemQuantity(item) {
      return item.type !== INVENTORY_TYPES.PACKAGE && !this.disableQuantity && !this.complete
    },
    updateBookingItems(item, quantity) {
      item.quantity = quantity || 1

      this.$emit('update-items')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/CheckoutItems/index.vue